import { render, staticRenderFns } from "./RadioView.vue?vue&type=template&id=2c0581cc&"
import script from "./RadioView.vue?vue&type=script&lang=js&"
export * from "./RadioView.vue?vue&type=script&lang=js&"
import style0 from "./RadioView.vue?vue&type=style&index=0&id=2c0581cc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports